const initialState = {
    wordCurrentPage: 0,
    clickedRowData: null,
    showWordPopUp: false
}

export const WORDS_ACTION_TYPE = {
    SET_CLICKED_ROW_DATA: 'SET_CLICKED_ROW_DATA',
    SET_SHOW_WORD_POP_UP: 'SET_SHOW_WORD_POP_UP',
    SET_WORD_CURRENT_PAGE: 'SET_WORD_CURRENT_PAGE'
}

const wordsReducer = (state = initialState, action) => {
    switch (action.type) {
        case (WORDS_ACTION_TYPE.SET_WORD_CURRENT_PAGE):
            return {
                ...state,
                wordCurrentPage: action.payload
            }
        case (WORDS_ACTION_TYPE.SET_SHOW_WORD_POP_UP):
            return {
                ...state,
                showWordPopUp: action.payload
            }
        case (WORDS_ACTION_TYPE.SET_CLICKED_ROW_DATA):
            return {
                ...state,
                clickedRowData: action.payload
            }
        default:
            return state
    }
}

export default wordsReducer